import { TimelineItem } from "entities/domain/conversations/timeline";
import { TimelineItemDTO } from "entities/dto/ConversationTimelineDTO";
import { messageTransformFromDtoToDomain } from "./conversationTransformers";

export function timelineItemFromDto(item: TimelineItemDTO): TimelineItem {
  return item.item_type === "message"
    ? { ...item, message: messageTransformFromDtoToDomain(item.message) }
    : item;
}
